import { Chip, Tooltip } from "@artprov/design-system";
import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import formatCurrencyForUi from "../../../common/utils/functions/formatCurrencyForUi.js";
import { useDropdownsStore } from "../../../common/zustand/dropdowns.store.js";

export default function TagsFilters({ appliedFilters = {}, onRemoveFilter }) {
  const sectores = useDropdownsStore((s) => s.sectores);
  
  const mapSectorDestino = (appliedFilters, sectores) => {
    if (!Array.isArray(appliedFilters?.sector_destino)) return appliedFilters

    // Si sectores está vacío y hay sector_destino, no mostrar nada aún
    if (sectores.length === 0 && appliedFilters.sector_destino.length > 0) {
      // Retornar appliedFilters sin sector_destino para evitar mostrar IDs
      const { sector_destino, ...rest } = appliedFilters;
      return rest;
    }

    return {
      ...appliedFilters,
      sector_destino: appliedFilters.sector_destino.map(ID => {
        const sector = sectores.find(s => s.ID === ID)
        return sector?.DESCRIPCION ?? ID
      })
    }
  }
  const mappedFilters = mapSectorDestino(appliedFilters, sectores)
  const entries = Object.entries(mappedFilters || {})

  const [maxVisibleChips, setMaxVisibleChips] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1300) {
        setMaxVisibleChips(2);
      } else {
        setMaxVisibleChips(3); 
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!entries.length) return null;

  const filterLabels = {
    razon_social: "",
    tipo_factura: "",
    estado: "",
    importe_desde: "Importe desde",
    importe_hasta: "Importe hasta",
    search: "Búsqueda",
    fecha_desde: "Desde",
    fecha_hasta: "Hasta"
  };

  const getLabelForFilter = (key, value) => {
    const label = filterLabels[key]
    const isImporte = key === "importe_desde" || key === "importe_hasta"

    const normalizedValue = Array.isArray(value)
      ? value.join(", ")
      : value

    const displayValue = isImporte
      ? `$ ${formatCurrencyForUi(normalizedValue)}`
      : normalizedValue

    if (!label) return displayValue

    return `${label}: ${displayValue}`
  }
  const visibleEntries = entries.slice(0, maxVisibleChips);
  const hiddenEntries = entries.slice(maxVisibleChips);
  const hasHiddenChips = hiddenEntries.length > 0;

  return (
    <div className={`flex flex-wrap gap-2 ${maxVisibleChips === 3 ? 'w-[550px]' : 'w-[270px]'}`}>
      {visibleEntries.map(([key, value]) => (
        <Chip
          key={`chip-${key}-${value}`}
          label={getLabelForFilter(key, value)}
          variant="primary"
          onClose={() => onRemoveFilter && onRemoveFilter(key)}
        />
      ))}

      {hasHiddenChips && (
        <div className="relative z-[99]">
          <Tooltip
            title="Filtros adicionales"
            tooltipBody={
              <div className="flex flex-col gap-1">
                {hiddenEntries.map(([key, value]) => (
                  <div key={`tooltip-${key}-${value}`} className="text-sm">
                    {getLabelForFilter(key, value)}
                  </div>
                ))}
              </div>
            }
            position="right-start"
          >
            <Chip variant="primary" key={`chip-tooltip`} label={`+${hiddenEntries.length}`}>
            </Chip>
          </Tooltip>
        </div>
      )}
    </div>
  );
}

TagsFilters.propTypes = {
  appliedFilters: PropTypes.object,
  onRemoveFilter: PropTypes.func,
};